import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { EoeDeviceStoreProducts } from '../../../../../components/EoeDeviceStoreProducts/EoeDeviceStoreProducts.js';
import { loadVirtualCatalogs } from '../../../../../selfservice/actions/index.js';
import type { CategoryProps } from '../../../../../common/types/category.js';

export const EoeStoreProducts = ({ category }: CategoryProps) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadVirtualCatalogs());
  }, [category.code, dispatch]);
  return <EoeDeviceStoreProducts category={category} />;
};
